export default __webpack_public_path__ + "static/media/added-2.2b479001.svg";